import * as R from 'ramda'

import { isFieldConfig } from './typeguards'
import type { IFieldConfig } from './types'

export const chainName = <T extends IFieldConfig>(...args: (string | T | undefined)[]): T => {
  const config = args.find((item) => typeof item === 'object') as T
  const name = args.reduce<string>((acc, cur) => {
    const curName = isFieldConfig(cur) ? cur.name : typeof cur === 'string' ? cur : ''
    return [acc, curName].filter(Boolean).join('.')
  }, '')

  return { ...config, name }
}

// DRAFT for FieldGroup
export const splitPathsByCommonPrefix = (paths: string[]) => {
  if (paths.length === 0) {
    return { sharedPath: [], relativePaths: [] }
  }

  const splitted = R.map(R.split('.'), paths)

  if (paths.length === 1) {
    const onlyPath = splitted[0]
    const head = R.init(onlyPath)
    const tail = onlyPath.length > 0 ? [onlyPath.slice(-1)] : [[]]
    return { sharedPath: head, relativePaths: tail }
  }

  const transposed = R.transpose(splitted)
  const sharedPath = R.pipe(
    R.takeWhile((segments: string[]) => R.all(R.equals(segments[0]), segments)),
    R.map(R.head),
    R.filter((s): s is string => typeof s === 'string'),
  )(transposed)

  const relativePaths = R.map((path) => R.drop(sharedPath.length, path), splitted)

  return { sharedPath, relativePaths }
}
